import API from './Api';
import APIExport from './ApiExport';

const WORKSPACE_SCOPE_HEADERS = ['X-Workspace-Id', 'X-Workspace-View-Id'] as const;

const scopedClients = [API, APIExport];

export const applyWorkspaceScopeHeaders = (headers: Record<string, string | null>) => {
  scopedClients.forEach((client) => Object.assign(client.defaults.headers.common, headers));
};

/**
 * Drops the workspace scope once the session leaves its client, on a client switch or a logout. A request that still
 * carries a workspace of the previous client is rejected with 403 when the backend enforces the authorized context.
 */
export const clearWorkspaceScopeHeaders = () => {
  scopedClients.forEach((client) => WORKSPACE_SCOPE_HEADERS.forEach((header) => {
    delete client.defaults.headers.common[header];
  }));
};
